import styled from 'styled-components';

import { Container } from '@xing-com/layout-primitives';
import { mediaConfined } from '@xing-com/layout-tokens';

export const StyledContainer = styled(Container)`
  max-width: 830px;
  @media ${mediaConfined} {
    min-height: calc(100vh - 152px);
  }
`;
